import React, { MouseEvent } from 'react';
import { Colors } from '@shared/styles';
import { convertViewStyleToCss } from '@shared/util/convertViewStyleToCss';
import { LinkProps } from './props';

export function Link({
  href,
  children = href,
  underline = true,
  color = Colors.v2.purple,
  style,
  stopPropagation = true,
  onPressWeb,
}: LinkProps) {
  const cssStyle = convertViewStyleToCss(style);
  const underlineStyle = getUnderlineStyle({ underline, color });

  const handlePress = (event: MouseEvent<HTMLAnchorElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    onPressWeb?.(event);
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      style={{ color, ...underlineStyle, ...cssStyle }}
      onClick={handlePress}
    >
      {children}
    </a>
  );
}

function getUnderlineStyle({ underline, color }: { underline: boolean; color: string }) {
  return underline
    ? {
        borderBottom: '1px solid',
        borderColor: color,
        textDecoration: 'none',
      }
    : {
        textDecoration: 'none',
      };
}
